import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/core/api.service';
import { Base64Service } from 'src/app/core/base64.service';
import { LoggerService } from 'src/app/core/logger.service';
import { NotificationsService } from 'src/app/core/notifications.service';
import { UserService } from 'src/app/core/user.service';
import { ValidateService } from 'src/app/core/validate.service';
import { BlendEvent, ErrCode, LinkSendUrlApiInput } from 'src/app/shared/models';
import { BlendService } from 'src/app/shared/services/blend.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'app-link-share',
  templateUrl: './link-share.component.html',
  styleUrls: ['./link-share.component.scss']
})
export class LinkShareComponent implements OnInit {
  @Input() link: any;
  @Input() showShareLinkDialog: boolean = false;
  @Input() fileName: string;
  @Input() openState: number;

  @Output() state = new EventEmitter<number>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<boolean>();
  @Output() showShareLinkDialogChange = new EventEmitter<boolean>();

  public errcode: ErrCode;
  public isButtonLoading: boolean = false;
  public isPro = false;
  public isOnTrial = false;
  public emailItems: string[] = [];
  public disableValidation = false;

  public errorMessage: string = 'Enter a valid email address.';
  public privateMessage: string = '';
  public email: string = '';
  public shareForm: FormGroup;
  public linkSendResult = 0;

  constructor(
        private api: ApiService,
        public base64: Base64Service,
        private fb: FormBuilder,
        private userService: UserService,
        private validateService: ValidateService,
        private snackbarService: SnackbarService,
        private blendService: BlendService,
  ) { }

  async ngOnInit() {

    this.emailItems = [];
    this.privateMessage = ''

    this.isPro = this.userService.get('is_pro');
        this.isOnTrial = this.userService.get('is_on_trial');
        this.shareForm = this.fb.group({
            email: [this.emailItems],
            message: [this.privateMessage],
            displayname: [this.base64.decode(this.userService.get('display_name')), Validators.required]
        });

    this.showShareLinkDialog = true;
}

onFocus() {
  this.disableValidation = false;
}

isSendButtonDisabled() {
  return this.emailItems.length == 0 ;
}

onChangeMessage = (privateMessage: string) => {
  this.privateMessage = privateMessage;
};

public onSubmit = async () => {
  this.blendService.track(BlendEvent.BUTTON_CLICKED, { button_text: 'Send link' });
  const email = this.shareForm.get('email').value;
  const displayName = this.shareForm.get('displayname').value;
  try {
      this.linkSendResult = 0;

      if (!this.validateService.isDisplayNameValid(displayName)) {
          throw { code: 1659 };
      }

      this.errcode = null;
      const label = this.link.label || this.base64.encode('(No name provided)');
      await this.api.execute('linksendurl', {
          publink_id: this.link.cachekey,
          sync_id: this.link.sync_id,
          displayname: this.shareForm.get('displayname').value,
          linkname: label,
          linkurl: this.base64.encode(this.link.linkUrl),
          emailaddress: this.base64.encode(this.emailItems.join(',')),
          message: (this.userService.get('is_pro'))
              ? this.base64.encode(this.privateMessage)
              : ''
      } as LinkSendUrlApiInput);
      this.linkSendResult = 1;
      this.closeAfterSendLink();
      this.snackbarService.showMessage("success", "Email has been successfully sent.");
  } catch (ex) {
      this.closeShareLinkDialog();
      this.errcode = ErrCode.fromException(ex);
      this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
  }
}

onEmailChange = (data: string[]) => {    
  this.emailItems= data;
};

onKeyDown = (event: KeyboardEvent) => {
  if (event.key === 'Enter' && !event.shiftKey) {
    event.preventDefault();
    if (!this.isSendButtonDisabled()) {
      this.onSubmit();
    }
  }
}

public setState(state: number) {
  this.state.emit(state);
}

onBack = () => {
  this.closeShareLinkDialog();
}

closeShareLinkDialog = () => {
  this.showShareLinkDialog = false;
  setTimeout(() => {
    this.showShareLinkDialogChange.next(false);
    this.setState(1);
  });
}

closeAfterSendLink = () => {
  this.showShareLinkDialog = false;
  setTimeout(() => { 
      this.showShareLinkDialogChange.next(false);
    });
}
}
